// // src/components/BrandAudit/GMBProfile.jsx
// import React, { useEffect, useState, useCallback } from 'react';
// import { auditAPI } from '../../services/api';

// const CACHE_TTL = 24 * 60 * 60 * 1000;
// const GOOGLE_API_KEY = "AIzaSyBJtCMipuagFVjD0z0beDpzXDsYWsbR-tQ"
// const cleanDomain = (url) =>
//   url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

// const getPhotoUrl = (name) =>
//   `https://places.googleapis.com/v1/${name}/media?maxWidthPx=800&key=${GOOGLE_API_KEY}`;


// const GMBProfile = ({
//   brandName,
//   domain,
//   location,       // city/area (fallback)
//   address,        // full address from BrandInfo (primary)
//   placeId,
//   gmbLink,
//   forceRefresh = false,
//   onConfirm,
// }) => {
//   const [localData, setLocalData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [activePhoto, setActivePhoto] = useState(0);
//   const [showHours, setShowHours] = useState(false);

//   const fetchAndCacheGMB = useCallback(async () => {
//     if (!brandName || (!domain && !placeId && !gmbLink)) {
//       console.warn('GMBProfile: missing params', { brandName, domain, placeId, gmbLink });
//       return;
//     }

//     const cleanedDomain = cleanDomain(domain || '');
//     const cacheKey = `gmbBrand_${cleanedDomain || placeId || gmbLink}_${location || 'noloc'}`;

//     if (!forceRefresh) {
//       try {
//         const cached = localStorage.getItem(cacheKey);
//         if (cached) {
//           const { timestamp, data } = JSON.parse(cached);
//           if (Date.now() - timestamp < CACHE_TTL) {
//             console.log('✅ GMB: using cached data');
//             setLocalData(normalizeApiData(data, address || location));
//             return;
//           }
//         }
//       } catch {}
//     }

//     setLoading(true);
//     try {
//       const apiParams = {
//         brand_name: brandName,
//         force_refresh: forceRefresh,
//         ...(cleanedDomain && { domain: cleanedDomain }),
//         ...(location && { location }),
//         ...(placeId ? { place_id: placeId } : (gmbLink ? { place_url: gmbLink } : {})),
//       };
//       console.log('🚀 GMB API params:', apiParams);

//       const response = await auditAPI.gmbAnalysis(apiParams);
//       const outerWrapper = response?.data?.data ?? response?.data;
//       if (!outerWrapper) throw new Error('Empty API response');

//       let brandData = null;
//       if (cleanedDomain && outerWrapper[cleanedDomain]) {
//         brandData = outerWrapper[cleanedDomain];
//       }
//       if (!brandData && cleanedDomain) {
//         const matchKey = Object.keys(outerWrapper).find(
//           k => k.includes(cleanedDomain) || cleanedDomain.includes(k)
//         );
//         if (matchKey) brandData = outerWrapper[matchKey];
//       }
//       if (!brandData) {
//         brandData = Object.values(outerWrapper).find(v => v?.is_primary === true);
//       }
//       if (!brandData && Object.values(outerWrapper).length) {
//         brandData = Object.values(outerWrapper)[0];
//       }
//       if (!brandData) throw new Error('Brand data not found');

//       const normalized = normalizeApiData(brandData, address || location);
//       localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: brandData }));
//       setLocalData(normalized);
//     } catch (err) {
//       console.error('GMB fetch failed:', err);
//       setLocalData(null);
//     } finally {
//       setLoading(false);
//     }
//   }, [brandName, domain, location, address, placeId, gmbLink, forceRefresh]);

//   const normalizeApiData = (data, fallbackAddress) => {
//     // Hours from weekdayDescriptions
//     let hoursArray = [];
//     if (data.opening_hours?.value?.weekdayDescriptions) {
//       hoursArray = data.opening_hours.value.weekdayDescriptions;
//     } else if (data.opening_hours?.weekdayDescriptions) {
//       hoursArray = data.opening_hours.weekdayDescriptions;
//     } else if (data.opening_hours?.value?.weekday_text) {
//       hoursArray = data.opening_hours.value.weekday_text;
//     } else if (data.opening_hours?.weekday_text) {
//       hoursArray = data.opening_hours.weekday_text;
//     }

//     // Open/closed based on current time – API provides status
//     const isOpen = data.opening_hours?.value?.status === 'open' ||
//                    data.opening_hours?.status === 'open';

//     const rating = data.reviews?.value?.rating ?? data.reviews?.rating ?? 0;
//     const reviews = data.reviews?.value?.count ?? data.reviews?.count ?? 0;

//     // Use the full address passed from BrandInfo
//     const finalAddress = fallbackAddress || data.full_address || data.address || '';

//     const searchQuery = encodeURIComponent(`${data.business_name} ${finalAddress}`);
//     const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${searchQuery}`;

//     return {
//       name:    data.business_name,
//       cat:     data.primary_category || 'Business',
//       rating,
//       reviews,
//       phone:   data.phone_number?.display ?? data.phone_number?.value ?? data.phone ?? '',
//       website: data.website_url?.display ?? data.website_url?.value ?? data.website ?? '',
//       addr:    finalAddress,
//       isOpen,
//       hours:   hoursArray,
//       mapsUrl,
//       photos:  Array.isArray(data.photos_sample) ? data.photos_sample : [],
//     };
//   };

//   useEffect(() => {
//     setLocalData(null);
//     setActivePhoto(0);
//     setShowHours(false);
//     fetchAndCacheGMB();
//   }, [fetchAndCacheGMB]);

//   const renderStars = (rating = 0) => {
//     const full = Math.floor(rating);
//     const half = rating % 1 >= 0.5;
//     return '★'.repeat(full) + (half ? '½' : '') + '☆'.repeat(5 - full - (half ? 1 : 0));
//   };

//   const toggleHours = () => setShowHours(!showHours);
//   const openDirections = () => {
//     const addr = encodeURIComponent(localData?.addr || brandName);
//     window.open(`https://www.google.com/maps/dir/?api=1&destination=${addr}`, '_blank');
//   };
//   const openReviews = () => {
//     const search = encodeURIComponent(`${brandName} reviews`);
//     window.open(`https://www.google.com/search?q=${search}`, '_blank');
//   };

//   const data = localData;
//   const isLoading = loading;

//   // Render uses exact static HTML classes
//   return (
//     <div className="card" id="card-2" style={{ padding: 0, overflow: 'hidden', borderRadius: '20px' }}>
//       {/* <div className="dev-note" style={{ margin: '20px 20px 0', borderRadius: '10px' }}>
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="#8B6DBF">
//           <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
//         </svg>
//         <span><strong>Developer note:</strong> GMB data fetched from Google Places API. Photos and hours are live.</span>
//       </div> */}

//       {isLoading && (
//         <div className="fetch-state show" style={{ padding: '40px', textAlign: 'center' }}>
//           <div className="spinner" />
//           <span>Fetching details for <strong>{brandName}</strong>…</span>
//         </div>
//       )}

//       {!isLoading && data && (
//         <div className="gmb-result show">
//           <div className="photo-grid">
//             {data.photos.length > 0 ? (
//             //   data.photos.slice(0, 5).map((url, idx) => (
//             //     <div key={idx} className={`photo-cell${idx === 0 ? ' main' : ''}`}>
//             //         <img
//             //             src={url}
//             //             alt=""
//             //             loading="lazy"
//             //             onError={(e) => {
//             //                 e.currentTarget.onerror = null;
//             //                 e.currentTarget.src =
//             //                 "data:image/svg+xml;charset=UTF-8," +
//             //                 encodeURIComponent(`
//             //                     <svg xmlns="http://www.w3.org/2000/svg" width="300" height="200">
//             //                     <rect width="100%" height="100%" fill="#e2e8f0"/>
//             //                     <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#64748b" font-size="16">
//             //                         No Image
//             //                     </text>
//             //                     </svg>
//             //                 `);
//             //             }}
//             //             />
//             //       {/* <img
//             //         src={url}
//             //         alt={`${data.name} photo ${idx + 1}`}
//             //         loading="lazy"
//             //         referrerPolicy="no-referrer"
//             //         onError={(e) => { e.currentTarget.style.display = 'none'; }}
//             //       /> */}
//             //     </div>
//             //   ))
//                 data.photos.slice(0, 5).map((photo, idx) => {
//                 const imgUrl = typeof photo === "string"
//                     ? photo // fallback if old data
//                     : getPhotoUrl(photo.name);

//                 return (
//                     <div key={idx} className={`photo-cell${idx === 0 ? ' main' : ''}`}>
//                     <img
//                         src={imgUrl}
//                         alt={`${data.name} photo ${idx + 1}`}
//                         loading="lazy"
//                         onError={(e) => {
//                         e.currentTarget.onerror = null;
//                         e.currentTarget.src = "/no-image.png";
//                         }}
//                     />
//                     </div>
//                 );
//                 })
//                 ) : (
//               <>
//                 <div className="photo-cell main" style={{ background: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>No photo</div>
//                 <div className="photo-cell" style={{ background: '#e2e8f0' }}></div>
//                 <div className="photo-cell" style={{ background: '#e2e8f0' }}></div>
//                 <div className="photo-cell" style={{ background: '#e2e8f0' }}></div>
//                 <div className="photo-cell" style={{ background: '#e2e8f0' }}></div>
//               </>
//             )}
//           </div>

//           <div className="gmb-info">
//             <div className="gmb-bname">{data.name}</div>
//             <div className="gmb-bcat">{data.cat}</div>
//             <div className="rrow">
//               <span className="rscore">{data.rating.toFixed(1)}</span>
//               <span className="stars">{renderStars(data.rating)}</span>
//               <span className="rcount">{data.reviews.toLocaleString()} reviews</span>
//               <span className="open-badge" style={data.isOpen ? {} : { background: '#fce8e6', color: '#c62828' }}>
//                 <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="10"/></svg>
//                 {data.isOpen ? 'Open now' : 'Closed now'}
//               </span>
//             </div>
//             <div className="divider"></div>

//             <div className="irow-gmb">
//               <svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>
//               {data.website ? <a href={data.website} target="_blank" rel="noopener noreferrer">{data.website}</a> : <span>—</span>}
//             </div>

//             <div className="irow-gmb">
//               <svg viewBox="0 0 24 24"><path d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/></svg>
//               <a href={data.mapsUrl} target="_blank" rel="noopener noreferrer">View GMB Profile on Google</a>
//             </div>

//             {data.hours.length > 0 && (
//               <div className="irow-gmb">
//                 <svg viewBox="0 0 24 24"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/></svg>
//                 <div>
//                   <button className={`hours-toggle ${showHours ? 'open' : ''}`} onClick={toggleHours}>
//                     Show hours
//                     <svg viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z"/></svg>
//                   </button>
//                   <div className={`hours-detail ${showHours ? 'show' : ''}`}>
//                     {data.hours.map((line, i) => {
//                       const [day, ...rest] = line.split(':');
//                       const time = rest.join(':').trim();
//                       const today = new Date().toLocaleString('en', { weekday: 'long' });
//                       const isToday = day.toLowerCase().includes(today.toLowerCase());
//                       return (
//                         <div key={i} className={`hrow ${isToday ? 'today' : ''}`}>
//                           <span className="day">{day.trim()}</span>
//                           <span className="time">{time || 'Closed'}</span>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div className="irow-gmb">
//               <svg viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
//               <span>{data.phone || '—'}</span>
//             </div>

//             <div className="irow-gmb">
//               <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
//               <span>{data.addr || '—'}</span>
//             </div>

//             <div className="gmb-actions">
//               <button className="gabtn" onClick={openDirections}>
//                 <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
//                 Directions
//               </button>
//               <button className="gabtn" onClick={() => window.open(data.mapsUrl, '_blank')}>
//                 <svg viewBox="0 0 24 24"><path d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/></svg>
//                 View on Google
//               </button>
//               <button className="gabtn" onClick={openReviews}>
//                 <svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/></svg>
//                 Reviews
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <button
//         className="btn"
//         onClick={() => onConfirm(data)}
//         disabled={!data || isLoading}
//         style={{ margin: '0 20px 20px', width: 'calc(100% - 40px)' }}
//       >
//         Confirm Brand Details
//         <svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
//       </button>
//     </div>
//   );
// };

// export default GMBProfile;

import React, { useEffect, useState, useCallback } from 'react';
import { auditAPI } from '../../services/api';

const CACHE_TTL = 24 * 60 * 60 * 1000;

const cleanDomain = (url) =>
  url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

// const getPhotoUrl = (name) =>
//   `https://places.googleapis.com/v1/${name}/media?maxWidthPx=800&key=${GOOGLE_API_KEY}`;

// const getPhotoUrl = (name) =>
//   `http://localhost:10000/api/audit/place-photo?name=${encodeURIComponent(name)}`;

//prod

 const getPhotoUrl = (name) =>
   `https://api.boostlyai.in/api/audit/place-photo?name=${encodeURIComponent(name)}`;


// ── Fix 3: compute open/closed from actual weekday hours ──────────────────
const computeIsOpen = (hoursArray) => {
  if (!hoursArray || hoursArray.length === 0) return null; // unknown

  const now = new Date();
  const dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const todayName = dayNames[now.getDay()];
  const currentMinutes = now.getHours() * 60 + now.getMinutes();

  // Find today's line e.g. "Monday: 9:00 AM – 6:00 PM" or "Monday: Closed"
  const todayLine = hoursArray.find(line =>
    line.toLowerCase().startsWith(todayName.toLowerCase())
  );
  if (!todayLine) return null;

  if (todayLine.toLowerCase().includes('closed')) return false;
  if (todayLine.toLowerCase().includes('open 24')) return true;

  // Parse time range — handles "9:00 AM – 6:00 PM" and "9:00 am - 6:00 pm"
  const timeMatch = todayLine.match(
    /(\d{1,2}:\d{2}\s*[AP]M)\s*[–\-]\s*(\d{1,2}:\d{2}\s*[AP]M)/i
  );
  if (!timeMatch) return null;

  const parseTime = (str) => {
    const [time, period] = str.trim().split(/\s+/);
    let [h, m] = time.split(':').map(Number);
    if (period?.toUpperCase() === 'PM' && h !== 12) h += 12;
    if (period?.toUpperCase() === 'AM' && h === 12) h = 0;
    return h * 60 + m;
  };

  const openMin  = parseTime(timeMatch[1]);
  const closeMin = parseTime(timeMatch[2]);

  // Handle overnight hours (e.g. 10 PM – 2 AM)
  if (closeMin < openMin) {
    return currentMinutes >= openMin || currentMinutes < closeMin;
  }
  return currentMinutes >= openMin && currentMinutes < closeMin;
};

const GMBProfile = ({
  brandName,
  domain,
  location,
  address,
  placeId,
  gmbLink,
  forceRefresh = false,
  onConfirm,
}) => {
  const [localData, setLocalData] = useState(null);
  const [loading, setLoading]     = useState(false);
  const [showHours, setShowHours] = useState(false);

  // ── Fix 2: extract primary_category from all possible API shapes ──────
  const extractPrimaryCategory = (data) => {
    return (
      data.primary_category ||
      data.primaryCategory  ||
      data.primary_type     ||
      data.primaryType      ||
      data.primary_category_display ||
      data.gmb_categories?.[0] ||
      data.categories?.[0] ||
      data.types?.[0]?.replace(/_/g, ' ') ||
      ''
    );
  };

  const normalizeApiData = useCallback((data, fallbackAddress) => {
    // Hours
    let hoursArray = [];
    if (data.opening_hours?.value?.weekdayDescriptions?.length)
      hoursArray = data.opening_hours.value.weekdayDescriptions;
    else if (data.opening_hours?.weekdayDescriptions?.length)
      hoursArray = data.opening_hours.weekdayDescriptions;
    else if (data.opening_hours?.value?.weekday_text?.length)
      hoursArray = data.opening_hours.value.weekday_text;
    else if (data.opening_hours?.weekday_text?.length)
      hoursArray = data.opening_hours.weekday_text;

    // Fix 3: compute real-time open status from hours
    const isOpen = computeIsOpen(hoursArray);

    const rating  = data.reviews?.value?.rating ?? data.reviews?.rating ?? 0;
    const reviews = data.reviews?.value?.count  ?? data.reviews?.count  ?? 0;

    const finalAddress = fallbackAddress || data.full_address || data.address || '';
    const searchQuery  = encodeURIComponent(`${data.business_name} ${finalAddress}`);
    const mapsUrl      = `https://www.google.com/maps/search/?api=1&query=${searchQuery}`;

    // Fix 2: use improved category extractor
    //const cat = extractPrimaryCategory(data) || 'Business';
    const cat =
    data.primary_category ||                    // ← GMBAuditResult.primary_category
    data.gmb_categories?.[0] ||                 // ← SerpApi categories[0]
    data.detected_industry?.replace(/_/g, ' ')  // ← industry as last resort
    || '';
    
    return {
      name:    data.business_name,
      cat,
      rating,
      reviews,
      phone:   data.phone_number?.display ?? data.phone_number?.value ?? data.phone ?? '',
      website: data.website_url?.display  ?? data.website_url?.value  ?? data.website ?? '',
      addr:    finalAddress,
      isOpen,
      hours:   hoursArray,
      mapsUrl,
      photos:  Array.isArray(data.photos_sample) ? data.photos_sample : [],
    };
  }, []);

  const fetchAndCacheGMB = useCallback(async () => {
    if (!brandName || (!domain && !placeId && !gmbLink)) return;

    const cleanedDomain = cleanDomain(domain || '');
    const cacheKey = `gmbBrand_${cleanedDomain || placeId || gmbLink}_${location || 'noloc'}`;

    if (!forceRefresh) {
      try {
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
          const { timestamp, data } = JSON.parse(cached);
          if (Date.now() - timestamp < CACHE_TTL) {
            setLocalData(normalizeApiData(data, address || location));
            return;
          }
        }
      } catch {}
    }

    setLoading(true);
    try {
      const apiParams = {
        brand_name:    brandName,
        force_refresh: forceRefresh,
        ...(cleanedDomain && { domain: cleanedDomain }),
        ...(location      && { location }),
        ...(placeId ? { place_id: placeId } : gmbLink ? { place_url: gmbLink } : {}),
      };

      const response    = await auditAPI.gmbAnalysis(apiParams);
      const outerWrapper = response?.data?.data ?? response?.data;
      if (!outerWrapper) throw new Error('Empty API response');

      let brandData = null;
      if (cleanedDomain && outerWrapper[cleanedDomain])
        brandData = outerWrapper[cleanedDomain];
      if (!brandData && cleanedDomain) {
        const matchKey = Object.keys(outerWrapper).find(
          k => k.includes(cleanedDomain) || cleanedDomain.includes(k)
        );
        if (matchKey) brandData = outerWrapper[matchKey];
      }
      if (!brandData)
        brandData = Object.values(outerWrapper).find(v => v?.is_primary === true);
      if (!brandData && Object.values(outerWrapper).length)
        brandData = Object.values(outerWrapper)[0];
      if (!brandData) throw new Error('Brand data not found');

      const normalized = normalizeApiData(brandData, address || location);
      localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: brandData }));
      setLocalData(normalized);
    } catch (err) {
      console.error('GMB fetch failed:', err);
      setLocalData(null);
    } finally {
      setLoading(false);
    }
  }, [brandName, domain, location, address, placeId, gmbLink, forceRefresh, normalizeApiData]);

  useEffect(() => {
    setLocalData(null);
    setShowHours(false);
    fetchAndCacheGMB();
  }, [fetchAndCacheGMB]);

  const renderStars = (rating = 0) => {
    const full = Math.floor(rating);
    const half = rating % 1 >= 0.5;
    return '★'.repeat(full) + (half ? '½' : '') + '☆'.repeat(5 - full - (half ? 1 : 0));
  };

  const openDirections = () => {
    const addr = encodeURIComponent(localData?.addr || brandName);
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${addr}`, '_blank');
  };

  const openReviews = () => {
    window.open(`https://www.google.com/search?q=${encodeURIComponent(`${brandName} reviews`)}`, '_blank');
  };

  const data      = localData;
  const isLoading = loading;

  return (
    <div className="card" id="card-2" style={{ padding: 0, overflow: 'hidden', borderRadius: '20px' }}>

      {isLoading && (
        <div className="fetch-state show" style={{ padding: '40px', textAlign: 'center' }}>
          <div className="spinner" />
          <span>Fetching details for <strong>{brandName}</strong>…</span>
        </div>
      )}

      {!isLoading && data && (
        <div className="gmb-result show">

          {/* ── Fix 1: Photo grid matching Google Maps mobile layout ── */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gridTemplateRows: '160px 80px',
            gap: 2,
            background: '#e2e8f0',
          }}>
            {/* Main large photo — spans full left column */}
            <div style={{
              gridColumn: '1',
              gridRow: '1 / 3',
              overflow: 'hidden',
              position: 'relative',
            }}>
              {data.photos[0] ? (
                <img
                  src={getPhotoUrl(data.photos[0].name)}
                  alt={data.name}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  onError={(e) => { e.currentTarget.style.background = '#cbd5e1'; e.currentTarget.style.display = 'none'; }}
                />
              ) : (
                <div style={{ width: '100%', height: '100%', background: '#cbd5e1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: 13 }}>
                  No photo
                </div>
              )}
            </div>

            {/* Top-right photo */}
            <div style={{ overflow: 'hidden', position: 'relative' }}>
              {data.photos[1] ? (
                <img
                  src={getPhotoUrl(data.photos[1].name)}
                  alt=""
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
              ) : <div style={{ width: '100%', height: '100%', background: '#cbd5e1' }} />}
            </div>

            {/* Bottom-right photo with "See photos" overlay */}
            <div style={{ overflow: 'hidden', position: 'relative' }}>
              {data.photos[2] ? (
                <>
                  <img
                    src={getPhotoUrl(data.photos[2].name)}
                    alt=""
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  />
                  {data.photos.length > 3 && (
                    <div style={{
                      position: 'absolute', inset: 0,
                      background: 'rgba(0,0,0,0.45)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      color: '#fff', fontSize: 13, fontWeight: 600, gap: 4,
                    }}>
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="white">
                        <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
                      </svg>
                      See photos
                    </div>
                  )}
                </>
              ) : <div style={{ width: '100%', height: '100%', background: '#cbd5e1' }} />}
            </div>
          </div>

          {/* ── Info section ── */}
          <div className="gmb-info">
            <div className="gmb-bname">{data.name}</div>

            {/* Fix 2: primary category displayed prominently */}
            {data.cat && data.cat !== 'Business' && (
              <div className="gmb-bcat" style={{
                fontSize: 13,
                color: 'var(--muted)',
                marginBottom: 6,
                marginTop: 2,
              }}>
                {data.cat}
              </div>
            )}

            {/* Rating row */}
            <div className="rrow">
              <span className="rscore">{data.rating.toFixed(1)}</span>
              <span className="stars">{renderStars(data.rating)}</span>
              <span className="rcount">{data.reviews.toLocaleString()} reviews</span>

              {/* Fix 3: real-time open/closed badge */}
              {data.isOpen !== null && (
                <span
                  className="open-badge"
                  style={data.isOpen
                    ? { background: '#e6f4ea', color: '#1e7e34' }
                    : { background: '#fce8e6', color: '#c62828' }
                  }
                >
                  <svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="12" r="10"/>
                  </svg>
                  {data.isOpen ? 'Open now' : 'Closed now'}
                </span>
              )}
            </div>

            <div className="divider" />

            {/* Website */}
            <div className="irow-gmb">
              <svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>
              {data.website
                ? <a href={data.website} target="_blank" rel="noopener noreferrer">{data.website}</a>
                : <span>—</span>}
            </div>

            {/* GMB link */}
            <div className="irow-gmb">
              <svg viewBox="0 0 24 24"><path d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/></svg>
              <a href={data.mapsUrl} target="_blank" rel="noopener noreferrer">View GMB Profile on Google</a>
            </div>

            {/* Hours */}
            {data.hours.length > 0 && (
              <div className="irow-gmb">
                <svg viewBox="0 0 24 24"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/></svg>
                <div>
                  <button className={`hours-toggle ${showHours ? 'open' : ''}`} onClick={() => setShowHours(p => !p)}>
                    {showHours ? 'Hide hours' : 'Show hours'}
                    <svg viewBox="0 0 24 24" style={{ transform: showHours ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>
                      <path d="M7 10l5 5 5-5z"/>
                    </svg>
                  </button>
                  {showHours && (
                    <div className="hours-detail show">
                      {data.hours.map((line, i) => {
                        const colonIdx = line.indexOf(':');
                        const day  = line.substring(0, colonIdx).trim();
                        const time = line.substring(colonIdx + 1).trim();
                        const today = new Date().toLocaleString('en', { weekday: 'long' });
                        const isToday = day.toLowerCase().includes(today.toLowerCase());
                        return (
                          <div key={i} className={`hrow ${isToday ? 'today' : ''}`}>
                            <span className="day">{day}</span>
                            <span className="time">{time || 'Closed'}</span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Phone */}
            <div className="irow-gmb">
              <svg viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
              <span>{data.phone || '—'}</span>
            </div>

            {/* Address */}
            <div className="irow-gmb">
              <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
              <span>{data.addr || '—'}</span>
            </div>

            {/* Action buttons */}
            <div className="gmb-actions">
              <button className="gabtn" onClick={openDirections}>
                <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
                Directions
              </button>
              <button className="gabtn" onClick={() => window.open(data.mapsUrl, '_blank')}>
                <svg viewBox="0 0 24 24"><path d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/></svg>
                View on Google
              </button>
              <button className="gabtn" onClick={openReviews}>
                <svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/></svg>
                Reviews
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Fix 4: CTA button text left-aligned */}
      <button
        className="btn"
        onClick={() => onConfirm(data)}
        disabled={!data || isLoading}
        // style={{
        //   margin: '0 20px 20px',
        //   width: 'calc(100% - 40px)',
        //   display: 'flex',
        //   alignItems: 'center',
        //   justifyContent: 'space-between',  // text left, arrow right
        //   textAlign: 'left',
        // }}
      >
        <span>Confirm Brand Details</span>
        <svg viewBox="0 0 24 24" fill="white" width="18" height="18">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
        </svg>
      </button>
    </div>
  );
};

export default GMBProfile;